export enum Messages {
  ERROR_GET_CHARTS = 'Fehler beim Abrufen der Charts.',
  ERROR_SUBMIT_VOTE = 'Fehler beim Abgeben des Votes.',
  SUCCESS_SUBMIT_VOTE = 'Dein Vote wurde erfolgreich gezählt.',
  ERROR_ALREADY_VOTED = 'Du hast bereits abgestimmt.',
  ERROR_SUBMIT_NEWCOMER = 'Problem beim Senden des Newcomers.',
  SUCESS_SUBMIT_NEWCOMER = 'Dein Newcomer wurde abgeschickt!',
  ERROR_INCOMPLETE_NEWCOMER = 'Bitte gib Titel und Interpret des Newcomers an.'
}
